export const privacyToc = [
  {
    id: 'changes',
    label: 'Changes to This Privacy Policy',
  },
  {
    id: 'information-collection',
    label: 'How We Collect and Use Your Personal Information',
  },
  {
    id: 'third-party',
    label: 'Third-party Websites and Links',
  },
  {
    id: 'childrens-data',
    label: "Children's Data",
  },
  {
    id: 'data-retention',
    label: 'Security and Retention of Your Information',
  },
  {
    id: 'your-rights',
    label: 'Your Rights and Choices',
  },
  {
    id: 'international-users',
    label: 'International Users',
  },
  {
    id: 'california-residents',
    label: 'California Residents',
  },
  {
    id: 'contact-us',
    label: 'Contact Us',
  },
];
